import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import isEqual from 'lodash.isequal';

// Actions
import {
    requestLoadTimesheets,
    canceledLoadTimesheets
} from '../../../../../../services/timesheets/actions';

// Selectors
import { selectLoadTimesheetsParams } from '../../../../../../services/timesheets/selectors';

interface Props {
    loadTimesheetsParams?: Record<string, any>;
    requestLoadTimesheets: Function;
    canceledLoadTimesheets: Function;
}

export class TimesheetsRequest extends React.PureComponent<Props> {
    componentDidMount() {
        this.props.requestLoadTimesheets();
    }

    componentDidUpdate(prevProps: Props) {
        if (
            !isEqual(
                prevProps.loadTimesheetsParams,
                this.props.loadTimesheetsParams
            )
        ) {
            this.props.requestLoadTimesheets();
        }
    }

    componentWillUnmount() {
        this.props.canceledLoadTimesheets();
    }

    render() {
        return null;
    }
}

const mapStateToProps = createStructuredSelector({
    loadTimesheetsParams: selectLoadTimesheetsParams
});

export default connect(
    mapStateToProps,
    {
        requestLoadTimesheets,
        canceledLoadTimesheets
    }
)(TimesheetsRequest);
